import React, { useState } from "react";
import styles from "./styles.module.scss";
import { Toggle } from "../../../../shared/Toggle/Toggle";
import { useCurrentAccountQuery } from "../../../../api/queries/useAccountQuery";
import { InfoCircleIcon } from "../../../../assets/Icons/InfoCircleIcon";
import { LockClosedIcon } from "../../../../assets/Icons/LockClosedIcon";
import { CircularProgress } from "../../../../shared/CircularProgress/CircularProgress";
import { useUpdateAppointmentRequireDobSettingMutation } from "../../../../api/appointments/useUpdateAppointmentRequireDobSettingMutation";
import { uiNotification } from "../../../../services/UINotificationService";

export function DobPolicy() {
  const { 0: isEnabled, 1: setIsEnabled } = useState(false);

  const { data: account, isFetching: isAccountLoading } =
    useCurrentAccountQuery({
      staleTime: 0,
      onSuccess: (data) => {
        setIsEnabled(data?.preferences?.requireAppointmentDob);
      },
    });

  const update = useUpdateAppointmentRequireDobSettingMutation({
    onError: () => {
      uiNotification.error("Unable to update the setting. Try again later");
      setIsEnabled((prev) => !prev);
    },
  });

  const isTouchMd = Boolean(account?.preferences?.isTouchMd);

  const onChange = () => {
    if (isTouchMd) {
      return;
    }

    setIsEnabled((prev) => !prev);
    update.mutate({
      isRequired: !isEnabled,
    });
  };

  return (
    <div className={styles.root}>
      <div className={styles.left}>
        <h3>Date of Birth Requirement</h3>
        <p>{`Require Date of Birth for Online & In-Clinic Booking`}</p>
        <div className={styles.alert}>
          <InfoCircleIcon width="16px" />
          Any changes made will only apply to future appointments
        </div>
        {isTouchMd && (
          <p>
            <i>
              The Date of Birth requirement is auto-enabled as part of the
              TouchMD integration.
              <br />
              Please note, it can not be disabled as long as the integration is
              active.
            </i>
          </p>
        )}
      </div>
      <div className={styles.right}>
        <Toggle
          isDisabled={isTouchMd || isAccountLoading || update.isLoading}
          isEnabled={isEnabled}
          onChange={onChange}
        >
          {isAccountLoading || update.isLoading ? (
            <CircularProgress size="small" color="gray1" />
          ) : null}
          {isTouchMd && !isAccountLoading && !update.isLoading && (
            <LockClosedIcon />
          )}
        </Toggle>
      </div>
    </div>
  );
}
